import Viewer from "~/js/asset-viewport/viewer";

export default class BlobViewer extends Viewer {
	static type = "binary";
	static supportedExtensions = ["safetensor", "ckpt", "zip", "tar", "safetensors"];

	loadAsync() {
		this.dom.content = document.createElement("div");
		this.dom.content.classList.add("blob-viewer");
		this.domElement().prepend(this.dom.content);
	}

	reloadAssetAsync(asset) {
		this.asset = asset;
	}
}
